import React, { useEffect, useState } from "react";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/activity/activity";
import moment from "moment";
import { GetActivityApi } from "../../api/request/activity/activity";
import UserAvatar from "../../components/common/UserAvatar";
import Search from "../../components/common/Search";

const Activity = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filtered, setFiltered] = useState([]);

  const updatedColumns = [
    {
      title: "User",
      dataIndex: "userDetails",
      render: (value) => (value ? value : "--"),
    },
    ...columns,
  ];

  const getActivity = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetActivityApi();
      setData(
        data?.data?.map((item) => {
          return {
            ...item,
            userDetails: <UserAvatar data={item?.user} />,
            created_at: item?.created_at
              ? moment(item?.created_at).format("lll")
              : "--",
          };
        })
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);

  useEffect(() => {
    setFiltered(data);
  }, [data]);

  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className="title">Activity</p>
        <div className="md:w-auto w-40">
          <Search data={data} setFiltered={setFiltered} />
        </div>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={updatedColumns}
          data={filtered}
          isLoading={isLoading}
          pagination={true}
        />
      </div>
    </div>
  );
};

export default Activity;
